import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.33337 8.66669H10.6667M5.33337 8.66669H5.33936M8.66671 11.3334H5.33337M10.6667 11.3334H10.6607" stroke="#72808F" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 1.33331V2.66665M4 1.33331V2.66665" stroke="#72808F" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.66663 8.16213C1.66663 5.25729 1.66663 3.80485 2.50137 2.90243C3.33612 2 4.67962 2 7.36663 2H8.63329C11.3203 2 12.6638 2 13.4986 2.90243C14.3333 3.80485 14.3333 5.25729 14.3333 8.16213V8.50453C14.3333 11.4094 14.3333 12.8618 13.4986 13.7643C12.6638 14.6667 11.3203 14.6667 8.63329 14.6667H7.36663C4.67962 14.6667 3.33612 14.6667 2.50137 13.7643C1.66663 12.8618 1.66663 11.4094 1.66663 8.50453V8.16213Z" stroke="#72808F" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2 5.33331H14" stroke="#72808F" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

export default SvgComponent
